import { deleteApiLogin } from "./deleteApiLogin";
import { postApiLogin } from "./postApiLogin";
import { postApiLoginAuthorize } from "./postApiLoginAuthorize";
import { postApiLoginCodeVerification } from "./postApiLoginCodeVerification";
import { postApiLoginEmailVerification } from "./postApiLoginEmailVerification";
import { postApiLoginForgotpassword } from "./postApiLoginForgotpassword";
import { postApiLoginForgotusername } from "./postApiLoginForgotusername";
import { postApiLoginRefreshToken } from "./postApiLoginRefreshToken";
import { postApiLoginValidateemailcodeforforgotpassword } from "./postApiLoginValidateemailcodeforforgotpassword";
import { postApiLoginValidateemailcodeforforgotusername } from "./postApiLoginValidateemailcodeforforgotusername";

export function loginController() {
  return {
    postApiLogin,
    deleteApiLogin,
    postApiLoginEmailVerification,
    postApiLoginCodeVerification,
    postApiLoginRefreshToken,
    postApiLoginAuthorize,
    postApiLoginForgotpassword,
    postApiLoginForgotusername,
    postApiLoginValidateemailcodeforforgotpassword,
    postApiLoginValidateemailcodeforforgotusername,
  };
}
